/**
 * 新闻资讯api
 * 新闻资讯相关接口
 *
 * OpenAPI spec version: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import NewsDetailVo from '../../news/model/NewsDetailVo';
import PagingNewsSummaryVo from '../../news/model/PagingNewsSummaryVo';
  /**
   * News service.
   * @module news/api/NewsApi
   * @version 0.1.0
   */

  /**
   * Constructs a new NewsApi. 
   * @alias module:news/api/NewsApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 获取新闻详情
     * @param {Integer} id 新闻ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:news/model/NewsDetailVo}
     */
this.getNewsDetail = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getNewsDetail";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = NewsDetailVo;
      return this.apiClient.callApi(
        '/api/news/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据预览地址查看新闻（匿名访问）
     * 通过预览地址匿名访问新闻内容（无需登录）。 - m: 新闻生成预览时的修改时间毫秒值 - s: 预览签名 - 若新闻在生成预览后被重新编辑，则老预览地址会失效 
     * @param {Integer} id 新闻ID
     * @param {Integer} m 新闻修改时间毫秒值（用于校验是否被重新编辑）
     * @param {String} s 预览签名（防篡改、防猜测）
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:news/model/NewsDetailVo}
     */
this.getNewsPreviewByLink = function(id, m, s) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getNewsPreviewByLink";
      }

      // verify the required parameter 'm' is set
      if (m == undefined || m == null) {
        throw "Missing the required parameter 'm' when calling getNewsPreviewByLink";
      }

      // verify the required parameter 's' is set
      if (s == undefined || s == null) {
        throw "Missing the required parameter 's' when calling getNewsPreviewByLink";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'm': m,
        's': s
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = NewsDetailVo;
      return this.apiClient.callApi(
        '/api/news/preview/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 分页获取新闻列表
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.categoryId 新闻分类：1-通知，2-动态，3-政策，不传则查询所有分类
     * @param {String} opts.searchText 搜索关键词（标题或内容）
     * @param {Integer} opts.page 页码，从1开始，默认为1 (default to 1)
     * @param {Integer} opts.pageSize 每页大小，默认为10 (default to 10)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:news/model/PagingNewsSummaryVo}
     */
this.listNews = function(opts) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'categoryId': opts['categoryId'],
        'searchText': opts['searchText'],
        'page': opts['page'],
        'pageSize': opts['pageSize']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingNewsSummaryVo;
      return this.apiClient.callApi(
        '/api/news/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
